import React from 'react';
import { Input } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class TextEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e.target.value;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <Input.TextArea
                className={this.props.source.readOnly ? "input-readonly" : ""}
                rows={4}
                readOnly={this.props.source.readOnly ? true : false}
                value={this.props.source.value}
                onChange={e => this.onChange(e)}
                placeholder={this.props.source.placeholder}
                style={{ fontSize: this.props.source.style && this.props.source.style.fontSize }} />
        );
    }
}

PropertyGridUtils.register("text", (source, propertyGrid) => <TextEditor source={source} propertyGrid={propertyGrid} />);